import { InjectionToken } from '@angular/core';
import { SitemapEntry } from '@wdx/clmi/clmi-swagger-gen';

/**
 * Interface for services that can match route paths to sitemap entries.
 * This allows the CustomRouteSerializer to append sitemap data to route data
 * without being tightly coupled to a specific app's NavigationService.
 */
export interface SitemapMatcherService {
    /**
     * Matches a route path to sitemap entries based on the path segments.
     * Returns an array of sitemap entries that match the route hierarchy.
     *
     * @param path - Array of path segments from the route
     * @param isAdminArea - Whether the route is in the admin area
     * @returns Array of matched sitemap entries, or undefined if sitemap is not loaded yet
     */
    matchPathToSitemap(
        path: string[],
        isAdminArea: boolean,
    ): SitemapEntry[] | undefined;

    /**
     * Gets the full sitemap for the given area.
     *
     * @param isAdminArea - Whether to get the admin sitemap
     * @returns The full sitemap array, or undefined if not loaded yet
     */
    getFullSitemap(isAdminArea: boolean): SitemapEntry[] | undefined;
}

/**
 * Injection token for SitemapMatcherService.
 * Apps should provide their implementation using this token.
 */
export const SITEMAP_MATCHER_SERVICE =
    new InjectionToken<SitemapMatcherService>('SitemapMatcherService');
